import React from 'react';

import { Box, H1, Text } from '@betterment/samba-react';

const Header: React.FC = () => {
  return (
    <Box css={{ pt: 'space.600', pb: 'space.300' }}>
      <H1 variant="title400" css={{ mb: 'space.200' }}>
        Refer a friend
      </H1>
      <Text
        as="p"
        color="text.weak"
        css={{
          marginBottom: 'space.0',
        }}
      >
        Get rewarded when your friends sign up for Betterment. Rewards are available for the first five referrals only.
      </Text>
    </Box>
  );
};

export default Header;
